import styled from 'styled-components';

import {deepLinkBlockWrapperStyles} from '../deepLinkBlock';

export const WeavePanelWrapper = styled.div`
  white-space: normal;
  margin-bottom: 24px;
  ${deepLinkBlockWrapperStyles}
`;
